import * as React from "react"
import { useIntl } from "react-intl"
import { Badge } from "@/components/ui/badge"
import type { Flashcard } from "@/types/flashcards"

export function CardList({
  cards,
  actions,
}: {
  cards: Flashcard[]
  actions?: (card: Flashcard) => React.ReactNode
}) {
  const intl = useIntl()
  return (
    <ol className="mt-4 divide-y divide-hairline overflow-hidden rounded-xl border border-hairline bg-page p-0">
      {cards.map((card, index) => (
        <li key={card.id} className="flex items-start gap-4 px-4 py-4">
          <span className="w-6 shrink-0 pt-0.5 text-right text-xs text-ink-muted">{index + 1}</span>
          <div className="grid min-w-0 flex-1 gap-3 sm:grid-cols-2">
            <div className="min-w-0">
              <div className="text-xs uppercase tracking-wider text-ink-muted">{intl.formatMessage({ id: "flashcards.front" })}</div>
              <div className="mt-1 whitespace-pre-wrap break-words text-sm text-ink-display">{card.front}</div>
            </div>
            <div className="min-w-0">
              <div className="text-xs uppercase tracking-wider text-ink-muted">{intl.formatMessage({ id: "flashcards.back_side" })}</div>
              <div className="mt-1 whitespace-pre-wrap break-words text-sm">{card.back}</div>
              {card.content_area_name && (
                <Badge tone="muted" className="mt-2">
                  {card.content_area_name}
                </Badge>
              )}
            </div>
          </div>
          {actions?.(card)}
        </li>
      ))}
    </ol>
  )
}
